var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tinymce-box-main"},[_c('textarea',{attrs:{"id":_vm.tinymceId}})])}
var staticRenderFns = []

export { render, staticRenderFns }